import { render, staticRenderFns } from "./SiprizLottoBoard.vue?vue&type=template&id=3713c620&scoped=true&"
import script from "./SiprizLottoBoard.vue?vue&type=script&lang=js&"
export * from "./SiprizLottoBoard.vue?vue&type=script&lang=js&"
import style0 from "./SiprizLottoBoard.vue?vue&type=style&index=0&id=3713c620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3713c620",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VFlex,VImg,VRow})
